const env = process.env.NODE_ENV;

export const apiBaseUrl = env === 'production'
  ? 'https://accountapi.emoera.com/api'
  : (process.env.VUE_APP_API_BASE_URL || '/api')

export const config = {
  qq: {
    appId: env === 'production' ? '102070688' : '102070688', //'生产环境APPID' : '开发环境APPID'
    redirectUri: `${window.location.origin}/oauth/qq/callback`
  },
  google: {
    clientId: '387740947304-rkvt3su0em2gppu82ft0hkdjhgno3cck.apps.googleusercontent.com',
    redirectUri: `${window.location.origin}/oauth/google/callback`,
    scope: 'openid email profile'
  },
  github: {
    clientId: 'Ov23liqdh6dZaJsOQvBM',
    redirectUri: `${window.location.origin}/oauth/github/callback`,
    scope: 'read:user user:email'
  },
  bohrium: {
    authorizeEndpoint: `${apiBaseUrl}/auth/bohrium/authorize`,
    redirectUri: `${window.location.origin}/oauth/bohrium/callback`
  },
  // ... 其他配置
} as const;

// 导出类型
export type Config = typeof config;
